import { render, staticRenderFns } from "./salaries_fdt.vue?vue&type=template&id=41586bfe&"
import script from "./salaries_fdt.vue?vue&type=script&lang=js&"
export * from "./salaries_fdt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports